import { ChangelogDataModel } from './app/modules/changelog/changelog-page/changelog.model';

export const changelogData: ChangelogDataModel[] = [
  {
    date: '05.28.2025',
    version: '1.1.51',
    titleUpdate: 'Improvements and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.3.png',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [
          { name: 'Updated the display of sub-charts in the General Chart' },
          { name: 'Removed sub-charts for the General Chart in Settings' },
          { name: 'Added a filter by country to the Offers table' },
        ],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Fixes icons problems' }, { name: 'Hidden inactive Offer URLs in the Deeplink generator' }],
      },
    ],
  },
  {
    date: '05.21.2025',
    version: '1.1.50',
    titleUpdate: 'Improvements and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.2.svg',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Added privacy policy section to Sign In / Sign Up pages' }],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [
          { name: 'Corrected currency update logic in Payment Details' },
          { name: 'Addressed bug where the sign-up page froze while reading the terms' },
          { name: 'Fixed error message handling when 2FA code couldn’t be sent during login' },
        ],
      },
    ],
  },
  {
    date: '05.14.2025',
    version: '1.1.49',
    titleUpdate: 'Improvements and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.1.svg',
    changesGroups: [
      {
        label: {
          title: 'New features',
          color: 'green',
        },
        listChanges: [{ name: 'Added WhatsApp field to the CRM' }],
      },
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Renamed Skype field to Microsoft Teams' }, { name: 'Updated error messages for a better user experience' }],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Fixed the bug when Advertiser ID and Brand are hidden in Tree, but shown in Click Table filters' }],
      },
    ],
  },
  {
    date: '05.07.2025',
    version: '1.1.48',
    titleUpdate: 'Improvements to Existing Features',
    img: 'assets/new-img/changelog/changelog-0.1.16.png',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Added a message about sending a code for 2FA' }],
      },
    ],
  },
  {
    date: '04.30.2025',
    version: '1.1.47',
    titleUpdate: 'New Features, Improvements, and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.15.png',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Security enhancements' }, { name: 'Updated filters to Marketing Tools in the Offer profile' }],
      },
    ],
  },
  {
    date: '04.23.2025',
    version: '1.1.46',
    titleUpdate: 'New Features, Improvements, and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.14.png',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Updated design of the IREV referral banner' }],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Fixed an error when Offers are not shown without country codes' }],
      },
    ],
  },
  {
    date: '04.16.2025',
    version: '1.1.45',
    titleUpdate: 'New Features, Improvements, and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.13.png',
    changesGroups: [
      {
        label: {
          title: 'New features',
          color: 'green',
        },
        listChanges: [{ name: 'Added Cookie consent banner according to the legal requirements' }],
      },
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [
          { name: 'Updated the country and payout fields for Offers in Offer table and profile' },
          {
            name: 'Added dynamic unsecured mode. From now the 2FA time will depend on the last action of the user in the platform, so if you use the platform, you will need to complete the 2FA less frequently',
          },
        ],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Updated the email field validation' }],
      },
    ],
  },
  {
    date: '04.09.2025',
    version: '1.1.44',
    titleUpdate: 'Improvements and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.12.png',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Added the Click Created At field to the Data Exporter' }, { name: 'General technical improvements' }],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Fixed the Portuguese localization in the calendar' }],
      },
    ],
  },
  {
    date: '04.02.2025',
    version: '1.1.43',
    titleUpdate: 'Improvements and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.11.png',
    changesGroups: [
      {
        label: {
          title: 'New features',
          color: 'green',
        },
        listChanges: [
          { name: 'Added the Russian language to the Affiliate Area' },
          { name: 'Added the Ukrainian language to the Affiliate Area' },
          { name: 'Added new chart widgets to the Dashboard metrics' },
        ],
      },
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Updated language switcher and sidebar icons' }, { name: 'Updated links to the API documentation' }],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Minor bug fixes' }],
      },
    ],
  },
  {
    date: '03.20.2025',
    version: '1.1.42',
    titleUpdate: 'Improvements and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.10.png',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Updated Sign Up and Login pages' }, { name: 'Changed the naming of the Log Out button' }],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [
          { name: 'Fixed the default currency bug in Invoice and Payment profiles' },
          { name: 'Fixed layout of the View Offer button in Spanish in the Offers table' },
          { name: 'Fixed the Refresh button position on mobile devices' },
          { name: 'Fixed the bug with incorrect domain when generating a short link for a Click' },
        ],
      },
    ],
  },
  {
    date: '03.05.2025',
    version: '1.1.41',
    titleUpdate: 'Improvements and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.9.png',
    changesGroups: [
      {
        label: {
          title: 'New features',
          color: 'green',
        },
        listChanges: [{ name: 'Added a new banner about the IREV Referral program to the Dashboard' }],
      },
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [
          { name: 'Added Portuguese translations to date tooltips' },
          { name: 'Added technical enhancements' },
          { name: 'Removed the «Preview URL» field in Offer profile' },
          { name: 'Removed the GDPR modal window in the Billing section and secured profile data by two-factor authentication (2FA)' },
        ],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [
          { name: 'Added missing Aff Sub 17 to Filters in Conversions table' },
          { name: 'Fixed Privacy error when trying to access the Request Only offer' },
        ],
      },
    ],
  },
  {
    date: '12.05.2025',
    version: '1.1.40',
    titleUpdate: 'Improvements and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.8.png',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [
          { name: 'Improved a Deeplink generator to save Offer URL parameters to links' },
          { name: 'Removed required validation for First Name, Last Name, and Phone fields' },
        ],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Excluded inactive Goals from Affiliate Trackers' }],
      },
    ],
  },
  {
    date: '02.05.2025',
    version: '1.1.39',
    titleUpdate: 'Improvements and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.7.png',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [
          { name: 'Made Skype and Telegram fields not required on the Profile page' },
          { name: 'Added login notifications that the account is pending or paused' },
          { name: 'Updated the pagination and moved it to the bottom of the pages' },
        ],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Improved localizations to Portuguese' }],
      },
    ],
  },
  {
    date: '01.29.2025',
    version: '1.1.38',
    titleUpdate: 'Improvements and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.6.png',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Added translation to Portuguese and Spanish to the Sign Up and Sign In pages' }],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [
          { name: 'Added support for Affiliates’ emails with a dash' },
          { name: 'Fixed the slow loading of the Data Exporter Conversions tab' },
          { name: 'Fixed the conversions sorting by Offer, Offer URL' },
        ],
      },
    ],
  },
  {
    date: '01.22.2025',
    version: '1.1.37',
    titleUpdate: 'Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.5.png',
    changesGroups: [
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [
          { name: 'Fixed naming in the Smart Links profile' },
          { name: 'Fix the layout in the Affiliate Area for English and Portuguese languages on the Profile page' },
          { name: 'Added missing localizations' },
        ],
      },
    ],
  },
  {
    date: '01.16.2025',
    version: '1.1.36',
    titleUpdate: 'Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.4.png',
    changesGroups: [
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Fixed and improved translations to Portuguese' }, { name: 'Fixed the content of tooltips' }],
      },
    ],
  },
  {
    date: '01.08.2025',
    version: '1.1.35',
    titleUpdate: 'Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.3.png',
    changesGroups: [
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [
          { name: 'Fixed the character encoding in the Data Exporter file' },
          { name: 'Fixed an error with a double display of errors in the Drilldown' },
        ],
      },
    ],
  },
  {
    date: '12.18.2024',
    version: '1.1.34',
    titleUpdate: 'New Updates and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.2.svg',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Optimized Offers table loading' }],
      },
    ],
  },
  {
    date: '12.11.2024',
    version: '1.1.33',
    titleUpdate: 'New Updates and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.1.svg',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [
          { name: 'Updated the display of boolean conversion profiles in the Drilldown Reports' },
          { name: 'Updated the notification to update the application' },
        ],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [
          { name: 'Fixed error with offer access for affiliates' },
          { name: 'Fixed layout in the Tracking Link Generator in Portuguese and Spanish' },
        ],
      },
    ],
  },
  {
    date: '12.04.2024',
    version: '1.1.32',
    titleUpdate: 'New Updates and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.16.png',
    changesGroups: [
      {
        label: { title: 'New features', color: 'green' },
        listChanges: [{ name: 'Added localization to Spanish' }],
      },
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Updated cards in the Offer table' }, { name: 'Aligned hash field in tables and profiles' }],
      },
    ],
  },
  {
    date: '11.27.2024',
    version: '1.1.31',
    titleUpdate: 'New Updates and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.15.png',
    changesGroups: [
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Updated texts in the Onboarding Tips and added tips to the Comparing Analytics' }],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Fixed the behavior of the 2FA window' }],
      },
    ],
  },
  {
    date: '11.20.2024',
    version: '1.1.30',
    titleUpdate: 'New Updates and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.14.png',
    changesGroups: [
      {
        label: {
          title: 'Common',
          color: 'green',
        },
        listChanges: [{ name: 'The platform version was increased to the stable v. 1.1.30' }],
      },
      {
        label: {
          title: 'Improvements to existing features',
          color: 'primary',
        },
        listChanges: [{ name: 'Changelogs moved to the Sidebar' }, { name: 'Added App button to the footer of the Menu' }],
      },
      {
        label: {
          title: 'Bug fixes',
          color: 'red',
        },
        listChanges: [{ name: 'Fixed the date format to the metrics on the Dashboard' }],
      },
    ],
  },
  {
    date: '11.13.2024',
    version: '0.1.29',
    titleUpdate: 'New Updates and Bug Fixes',
    img: 'assets/new-img/changelog/changelog-0.1.13.png',
    changesGroups: [
      {
        label: {
          title: 'Common',
          color: 'primary',
        },
        listChanges: [
          { name: 'Improved the loading of items in the Offers table' },
          { name: 'Added the Not Requested filter to the Offers table' },
        ],
      },
      {
        label: {
          title: 'Bugs',
          color: 'red',
        },
        listChanges: [
          { name: 'Fixed the displaying of the Payout Type field in the Conversion profile' },
          { name: 'Fixed the dead-end page for blocked users' },
          { name: 'Fixed texts across the platform' },
        ],
      },
    ],
  },
  {
    date: '10.30.2024',
    version: '0.1.28',
    titleUpdate: 'Common',
    img: 'assets/new-img/changelog/changelog-0.1.12.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Improved cards in the Offer table' }],
      },
    ],
  },
  {
    date: '10.23.2024',
    version: '0.1.27',
    titleUpdate: 'Common',
    img: 'assets/new-img/changelog/changelog-0.1.11.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Unified table filters across the platform' }],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Fixed the displaying of the currency selector on mobile devices' }],
      },
    ],
  },
  {
    date: '10.16.2024',
    titleUpdate: 'Common',
    version: '0.1.26',
    img: 'assets/new-img/changelog/changelog-0.1.10.png',
    changesGroups: [
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [
          { name: 'Fixed the data in transaction-related metrics when quick date frames are selected' },
          { name: 'Fixed the logging out process when credentials are changed' },
        ],
      },
    ],
  },
  {
    date: '10.09.2024',
    titleUpdate: 'Common',
    version: '0.1.25',
    img: 'assets/new-img/changelog/changelog-0.1.9.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Added QR code option to the Offer Tracking Link' }, { name: 'Updated icons across the platform' }],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Fixed the missing Plus button on the Affiliate Trackers page for mobile devices' }],
      },
    ],
  },
  {
    date: '10.02.2024',
    titleUpdate: 'Common',
    version: '0.1.24',
    img: 'assets/new-img/changelog/changelog-0.1.8.png',
    changesGroups: [
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [
          { name: 'Fixed the display of multiple payouts in the Offer profile' },
          { name: 'Removed the second search field that appears in the traffic data tables' },
          { name: 'Fixed the display of date filters in Dashboard for mobile devices' },
        ],
      },
    ],
  },
  {
    date: '09.24.2024',
    titleUpdate: 'Common',
    version: '0.1.23',
    img: 'assets/new-img/changelog/changelog-0.1.7.png',
    changesGroups: [
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Fixed the display of data in Offers table' }, { name: 'Fixed quick filters in the Offers section' }],
      },
    ],
  },
  {
    date: '08.12.2024',
    titleUpdate: 'Common',
    version: '0.1.22',
    img: 'assets/new-img/changelog/changelog-0.1.6.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Added the list of related conversions to Click profile' }, { name: 'Added Comparing Analytics' }],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Fixed the success message after  registration' }],
      },
    ],
  },
  {
    date: '08.05.2024',
    titleUpdate: 'Common',
    version: '0.1.21',
    img: 'assets/new-img/changelog/changelog-0.1.5.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [
          { name: 'Added the hash filter with multiselect option to the Clicks table' },
          { name: 'Added the name filter to the Offers table' },
        ],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Fixed errors when trying to restore the password' }],
      },
    ],
  },
  {
    date: '07.17.2024',
    titleUpdate: 'Common',
    version: '0.1.20',
    img: 'assets/new-img/changelog/changelog-0.1.4.png',
    changesGroups: [
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [
          { name: 'Fixed an error from changing metrics in Dashboard Widgets' },
          { name: 'Fixed the displaying of countries in Offers' },
          { name: 'Fixed date selector for the General Chart' },
          { name: 'Fixed behavior of the Request Access button' },
        ],
      },
    ],
  },
  {
    date: '07.15.2024',
    titleUpdate: 'Common',
    version: '0.1.19',
    img: 'assets/new-img/changelog/changelog-0.1.3.png',
    changesGroups: [
      {
        label: { title: 'Features', color: 'green' },
        listChanges: [{ name: 'Added an extensive public API with most of the functionality of the Affiliate Area' }],
      },
    ],
  },
  {
    date: '06.19.2024',
    titleUpdate: 'Common',
    version: '0.1.18',
    img: 'assets/new-img/changelog/changelog-0.1.2.svg',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Changed color of notifications about code confirmation' }],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [
          { name: 'Fixed the alignment of numbers for onboarding tooltips' },
          { name: 'Fixed pagination for empty tables across the CRM' },
          { name: 'Fixed the duplication of the “Payout Model” filter for the Conversions table' },
          { name: 'Fixed the generation of PDF invoices' },
        ],
      },
    ],
  },
  {
    date: '06.17.2024',
    titleUpdate: 'Features',
    version: '0.1.17',
    img: 'assets/new-img/changelog/changelog-0.1.1.svg',
    changesGroups: [
      {
        label: { title: 'Features', color: 'green' },
        listChanges: [{ name: 'Added unique API tokens' }],
      },
    ],
  },
  {
    date: '04.18.2024',
    titleUpdate: 'Common',
    version: '0.1.16',
    img: 'assets/new-img/changelog/changelog-0.1.16.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Optimized Drilldown Reports' }, { name: 'Added the Earnings model to metrics' }],
      },
    ],
  },
  {
    date: '04.17.2024',
    titleUpdate: 'Features',
    version: '0.1.15',
    img: 'assets/new-img/changelog/changelog-0.1.15.png',
    changesGroups: [
      {
        label: { title: 'Features', color: 'green' },
        listChanges: [{ name: 'Added new Earnings widget' }],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Fixed date filters in traffic data tables' }],
      },
    ],
  },
  {
    date: '03.21.2024',
    titleUpdate: 'Bugs',
    version: '0.1.14',
    img: 'assets/new-img/changelog/changelog-0.1.14.png',
    changesGroups: [
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [
          { name: 'Fixed the display of payment rules with 3 or more conditions in the Offers table' },
          { name: 'Fixed the display of columns in the Drilldown table with empty report' },
          { name: 'Fixed endless editing of Invoices' },
          { name: 'Fixed excessive columns in the CSV file in Data Exporter' },
          { name: 'Fixed the Click Profile page for imported clicks' },
          { name: 'Fixed the display of the “View Offer” button' },
          { name: 'Fixed the display of long descriptions in columns in Data Exporter' },
        ],
      },
    ],
  },
  {
    date: '03.11.2024',
    titleUpdate: 'Common',
    version: '0.1.13',
    img: 'assets/new-img/changelog/changelog-0.1.13.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Added the “show more” button for Marketing Information widget in Offers' }],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [
          { name: 'Fixed editing of  Smart Links' },
          { name: 'Fixed the display of financial values in Drilldown Reports' },
          { name: 'Fixed the Country and Region selector in Affiliate Questions' },
          { name: 'Fixed display of Marketing Information' },
          { name: 'Fixed editing of Invoices' },
          { name: 'Fixed the position of the “View Offer” button' },
        ],
      },
    ],
  },
  {
    date: '01.24.2024',
    titleUpdate: 'Features',
    version: '0.1.12',
    img: 'assets/new-img/changelog/changelog-0.1.12.png',
    changesGroups: [
      {
        label: { title: 'Features', color: 'green' },
        listChanges: [
          { name: 'Improved Date Pickers across the platform' },
          { name: 'Added lead information columns to the Conversions table' },
        ],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Fixed updates of Payout Models in the Offers table' }],
      },
    ],
  },
  {
    date: '12.26.2023',
    titleUpdate: 'New Features',
    version: '0.1.11',
    img: 'assets/new-img/changelog/changelog-0.1.11.png',
    changesGroups: [
      {
        label: { title: 'Features', color: 'green' },
        listChanges: [{ name: 'Added offer review image' }, { name: 'Improved the Offers table' }, { name: 'Added Offer Requests' }],
      },
    ],
  },
  {
    date: '10.12.2023',
    titleUpdate: 'New Features',
    version: '0.1.10',
    img: 'assets/new-img/changelog/changelog-0.1.10.png',
    changesGroups: [
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Fixed fields in payment methods' }, { name: 'Fixed the display of wire transfer in payment methods' }],
      },
    ],
  },
  {
    date: '08.28.2023',
    titleUpdate: 'New Features',
    version: '0.1.9',
    img: 'assets/new-img/changelog/changelog-0.1.9.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [
          { name: 'Improved 2FA enabling process and design  in Affiliate Area' },
          { name: 'Added 2FA protection for financial data  in Affiliate Area' },
        ],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Fixed error message for changing default payment method' }],
      },
    ],
  },
  {
    date: '08.10.2023',
    titleUpdate: 'New Features',
    version: '0.1.8',
    img: 'assets/new-img/changelog/changelog-0.1.8.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Changed calculation of  values in top widget in Earnings' }],
      },
    ],
  },
  {
    date: '07.24.2023',
    titleUpdate: 'New Features',
    version: '0.1.7',
    img: 'assets/new-img/changelog/changelog-0.1.7.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Improved Payment Methods' }, { name: 'Added the modal window if default payment method wasn’t specified' }],
      },
    ],
  },
  {
    date: '07.03.2023',
    titleUpdate: 'New Features',
    version: '0.1.6',
    img: 'assets/new-img/changelog/changelog-0.1.6.png',
    changesGroups: [
      {
        label: { title: 'Features', color: 'green' },
        listChanges: [{ name: 'Added Financial Tools' }, { name: 'Added file management in Invoices' }],
      },
    ],
  },
  {
    date: '04.27.2023',
    titleUpdate: 'New Features',
    version: '0.1.5',
    img: 'assets/new-img/changelog/changelog-0.1.5.png',
    changesGroups: [
      {
        label: { title: 'Features', color: 'green' },
        listChanges: [{ name: 'Added Fees for Affiliate Masters' }],
      },
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Added a referral link to Affiliate Groups' }],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Fixed master affiliate relogin' }],
      },
    ],
  },
  {
    date: '12.30.2022',
    titleUpdate: 'New Features',
    version: '0.1.4',
    img: 'assets/new-img/changelog/changelog-0.1.4.png',
    changesGroups: [
      {
        label: { title: 'Features', color: 'green' },
        listChanges: [
          { name: 'Added Master Affiliate' },
          { name: 'Added selectors for device info' },
          { name: 'Added API Token table into Profile' },
        ],
      },
      {
        label: { title: 'Bugs', color: 'red' },
        listChanges: [{ name: 'Removed dropbox from registration menu' }, { name: 'Fixed instructions in registration menu' }],
      },
    ],
  },
  {
    date: '12.08.2022',
    titleUpdate: 'New Features',
    version: '0.1.3',
    img: 'assets/new-img/changelog/changelog-0.1.3.png',
    changesGroups: [
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [{ name: 'Removed Copy Link button from Offer ID' }, { name: 'Removed unnecessary filters from Clicks table' }],
      },
    ],
  },
  {
    date: '2022-11-28',
    titleUpdate: 'New Features',
    version: '0.1.2',
    img: 'assets/new-img/changelog/changelog-0.1.2.svg',
    changesGroups: [
      {
        label: { title: 'Features', color: 'green' },
        listChanges: [
          { name: 'Added manually created Invoices' },
          { name: 'Added Marketing Tools' },
          { name: 'Added API Token table into Profile' },
        ],
      },
      {
        label: { title: 'Common', color: 'primary' },
        listChanges: [
          { name: 'Redesigned Offer ID page' },
          { name: 'Added Tracking Link generator to Dashboard' },
          { name: 'Improved Offers page' },
          { name: 'Added Animations for Onboarding Tips' },
        ],
      },
    ],
  },
  {
    date: '2022-11-15',
    titleUpdate: 'New Features',
    version: '0.1.1',
    img: 'assets/new-img/changelog/changelog-0.1.1.svg',
    changesGroups: [
      {
        label: { title: 'Features', color: 'green' },
        listChanges: [{ name: 'Improved Smart Link' }, { name: 'Added an expand button in the header' }],
      },
    ],
  },
];
